export const MONTH_NAMES = [
    'JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE',
    'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'
];

export const BAR_COLORS = [
    '#1976d2', '#0288d1', '#388e3c', '#8bc34a', '#fbc02d',
    '#ffa000', '#f57c00', '#d32f2f', '#c2185b', '#7b1fa2',
    '#512da8', '#303f9f'
];

export const PIE_COLORS = [
    '#8bc34a', '#ff9800', '#64b5f6', '#e57373', '#ffd54f'
];

export const COLORS = [
    '#1976d2', '#dc004e', '#388e3c', '#f57c00', '#7b1fa2',
    '#0288d1', '#c2185b', '#8bc34a', '#ffa000', '#512da8'
];